// tslint:disable:variable-name

export class EmailSettings {
    id: string;
    name: string;
    email: string;
    language: string;

    /* EmailSettings management */
    subscriptions: any;
    verified: boolean;
    ver_code: string;
    ver_expire_time: Date;

    /* Custom fields */
    custom_hdr: any;
    custom_dat: any;
}
